/** 차트 컬러 팔레트 — SVG attribute에 CSS var() 사용 불가하므로 hex 값으로 제공 */

export const CHART_COLORS = {
  primary: '#0EA5E9',
  primaryLight: '#E0F2FE',
  info: '#3b82f6',
  infoLight: '#dbeafe',
  success: '#22c55e',
  successLight: '#dcfce7',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  danger: '#ef4444',
  dangerLight: '#fee2e2',
  gray: '#94A3B8',
  grayLight: '#E2E8F0',
} as const

export const CHART_PALETTE = [
  '#0EA5E9', '#3b82f6', '#22c55e', '#f59e0b', '#ef4444',
  '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6', '#f97316',
] as const
